<template>
  <div class="coupon">
    <div class="modal-header" slot="header">
      <label class="modal-header-text">補助クーポン</label>
    </div>
    <div class="modal-body">
      <div>
        ※希望の枚数にご変更お願いします。<br/>
        ※契約によりご利用いただける補助クーポンは異なります。利用可能補助クーポンはマイページまたはプランページをご確認ください。<br/>
        自動補助クーポン：自動で利用となるため、選択はできません。<br/>
        任意補助クーポン：本画面より申請をお願いします。申請しない場合は０枚をご選択ください。<br/>
        ※複数の補助クーポンをお持ちの場合、各補助クーポンの枚数選択順により合計補助額が異なる可能性がございます。<br/>
      </div>
      <div v-show="forceUseSubsidys.length > 0" class="coupon-amount-desc">
        <label>自動補助クーポン</label>
        <span>計 {{ totalForceUseDiscount | formatCurrency }}</span>
      </div>
      <!-- #43515 ↓↓このブロックは仕様変更で非表示にする。既存処理への影響を考慮しCSSでの非表示とする↓↓ -->
      <div
        class="coupon-optional-radio-panel"
        v-show="subsidyData.length > forceUseSubsidys.length && canUseOptional === true"
      >
        <a-radio-group
          class="coupon-option-radio"
          v-model="couponOption"
          :defaultValue="couponOption"
          @change="onChangeCouponOption"
        >
          <a-radio :value="0"> 選択補助クーポンを最大限利用する </a-radio>
          <a-radio :value="1"> 選択補助クーポンを一部利用する </a-radio>
          <a-radio :value="2"> 選択補助クーポンを利用しない </a-radio>
        </a-radio-group>
      </div>
      <!-- #43515 ↑↑このブロックは仕様変更で非表示にする。既存処理への影響を考慮しCSSでの非表示とする↑↑ -->
      <div
        class="coupon-amount-desc"
        v-show="subsidyData.length > forceUseSubsidys.length && canUseOptional === true"
      >
        <label>選択補助クーポン</label>
        <span
          >計 {{ (totalDiscountAmount - totalForceUseDiscount) | formatCurrency }}</span
        >
      </div>

      <section class="coupon-section">
        <a-collapse
          v-model="couponActiveKey"
          accordion
          :bordered="false"
          class="coupon-collapse"
          v-show="subsidyData.length > forceUseSubsidys.length && canUseOptional === true"
        >
          <a-collapse-panel
            class="coupon-collapse-item"
            v-for="(group, gIdx) in groupSubsidyDetailList"
            :key="`group-info-${gIdx}`"
          >
            <template slot="header">
              <span class="text-epip">{{ group.groupName }}</span>
            </template>
            <div class="coupon-collapse-body__group">
              <div class="coupon-item-price-desc">
                <p
                  v-show="
                    get(group, 'receptionDateFrom') ||
                    get(group, 'receptionDateTo')
                  "
                >
                  申込期限 {{
                    get(group, 'receptionDateFrom') | formatDate
                  }}～{{ get(group, 'receptionDateTo') | formatDate }}
                </p>

                <!-- グループ補助金：保有枚数 -->
                <!-- 利用制限単位（usedLimUnit）が[02：契約ID毎][03：契約ID合計毎]の場合、非表示とする -->
                <div
                  v-if="group.usedLimUnit != '02' && group.usedLimUnit != '03' 
                      && group.groupRemainingCountLabel >= 0 && group.groupRemainingCountLabel !== null"
                >
                  <span>保有枚数&nbsp;</span>
                  <!-- 上限枚数と残枚数が設定されている場合：「X/Y枚」 -->
                  <span v-if="group.parsonalUsedMaxCnt !== null">
                    {{ group.groupRemainingCountLabel | formatInteger }}
                    /{{group.parsonalUsedMaxCnt | formatInteger}}
                    枚
                  </span>
                  <!-- 上限枚数未設定かつ残枚数が設定されている場合：「X枚」 -->
                  <span v-if="group.parsonalUsedMaxCnt == null">
                    {{ group.groupRemainingCountLabel | formatInteger }}
                    枚
                  </span>
                </div>

                <!-- 企業補助金: 利用可能残金 -->
                <div
                  v-if="group.groupRemainingAmountLabel >= 0 && group.groupRemainingAmountLabel !== null"
                >
                  <span>利用可能残金額&nbsp;</span>
                  <!-- 上限金額と残金が設定されている場合：「X/Y円」 -->
                  <span v-if="group.parsonalUsedMaxTotalAmt !== null" class="w-7/12 md:w-5/12 sm:w-7/12 md:text-xs">
                    {{ group.groupRemainingAmountLabel | formatInteger }}
                    /{{group.parsonalUsedMaxTotalAmt | formatInteger}}
                    円
                  </span>
                  <!-- 上限金額が未設定かつ残金が設定されている場合：「X円」 -->
                  <span v-if="group.parsonalUsedMaxTotalAmt == null" class="w-7/12 md:w-5/12 sm:w-7/12 md:text-xs">
                    {{ group.groupRemainingAmountLabel | formatInteger }}
                    円
                  </span>
                </div>

                <div class="coupon-collapse-item-desc1">
                  <p
                    template
                    class="planDetail"
                    v-for="(desc, index) in getGroupCouponDescrition(group)"
                    v-html="desc"
                    :key="index"
                  />
                </div>
                <div>
                  {{ group.dispNoteComment }}
                </div>
              </div>
              <a-collapse
                v-model="groupCouponActiveKey"
                accordion
                :bordered="false"
                class="coupon-collapse"
              >
                <a-collapse-panel
                  class="coupon-collapse-item"
                  v-for="(subsidy, idx) in group.subsidyDetailList"
                  :key="`group-subsidy-info-${gIdx}-${idx}`"
                  v-show="
                    subsidy.availableData.usedFormDiv !== CONST_DATA.USED_FORM_DIV.FORCED &&
                    visibleCoupons[subsidy.availableData.subsidyId]
                  "
                >
                  <template slot="header">
                    <span class="text-epip">{{ subsidy.availableData.dispSubsidyNm }}</span>
                  </template>
                  <div class="coupon-collapse-body__group">
                    <SubsidyDetail
                      :subsidy="subsidy"
                      :descrition="getCouponDescrition(subsidy)"
                    />
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </a-collapse-panel>
          <a-collapse-panel
            class="coupon-collapse-item"
            v-for="(subsidy, idx) in subsidyDetailList"
            :key="`subsidy-info-${idx}`"
            v-show="
              subsidy.availableData.usedFormDiv !== CONST_DATA.USED_FORM_DIV.FORCED &&
              visibleCoupons[subsidy.availableData.subsidyId]
            "
          >
            <template slot="header">
              <span class="text-epip">{{ subsidy.availableData.dispSubsidyNm }}</span>
            </template>
            <div class="coupon-collapse-body">
              <SubsidyDetail
                :subsidy="subsidy"
                :descrition="getCouponDescrition(subsidy)"
              />
            </div>
          </a-collapse-panel>
        </a-collapse>
      </section>

      <div
        class="coupon-item-day"
        v-for="(day, dayIdx) in stayNightDetails"
        :key="`coupon-item-day-${dayIdx}`"
        v-show="subsidyData.length > forceUseSubsidys.length && canUseOptional === true"
      >
        <label class="title">{{ dayIdx + 1 }}泊目</label>

        <a-collapse
          v-model="couponActiveKey"
          accordion
          :bordered="false"
          class="coupon-collapse"
          v-show="subsidyData.length > forceUseSubsidys.length && canUseOptional === true"
        >
          <a-collapse-panel
            class="coupon-collapse-item"
            v-for="(subsidy, idx) in day.coupons"
            :key="`subsidy-${dayIdx}-${idx}`"
            v-show="
              subsidy.availableData.usedFormDiv !== CONST_DATA.USED_FORM_DIV.FORCED &&
              visibleCoupons[subsidy.availableData.subsidyId] &&
              availableCheckForDate(day, subsidy) &&
              availableCheckAccompany(day, subsidy) &&
              (reRenderCouponList || !reRenderCouponList)
            "
          >
            <template slot="header">
              <span class="text-epip">{{ subsidy.availableData.dispSubsidyNm }}</span>
            </template>
            <div class="coupon-collapse-body">
              <div class="coupon-collapse-item-price">
                <!-- RENDER COUPON PRICE BASE RELATIONSHIP AND EACH DAYS -->
                <!-- その他会員（続柄コード：C-205-9）は表示しない -->
                <div
                    v-for="(price, priceIdx) in subsidy.availableData.priceList"
                    :key="`coupon-item-price-list=${priceIdx}`"
                >
                  <div
                    class="coupon-collapse-item-price-row"
                    v-if="price.relationshipCode !== 'C-205-9'"
                    v-show="checkLimApplicableDateFrom(day, price)"
                  >
                    <span class="price-label"
                      >{{ price.priceLabel }}: {{ price.price | formatCurrency }}</span
                    >
                    <a-select
                      v-if="[0, 2].includes(couponOption)"
                      v-model="price.useCnt"
                      :options="getSubsidyOptions(day, subsidy, price)"
                      @change="onChangeCouponUseCnt"
                      class="w-20"
                      style="width: 5rem"
                      :disabled="
                        [0, 2].includes(couponOption) ||
                        getSubsidyOptions(day, subsidy, price).length <= 1 ||
                        checkDisableByAgeType(price.ageType)

                      "
                    />
                    <a-select
                      v-else
                      v-model="price.selectUseCnt"
                      :options="getSubsidyOptions(day, subsidy, price)"
                      @change="onChangeCouponUseCnt()"
                      class="w-20"
                      style="width: 5rem"
                      :disabled="getSubsidyOptions(day, subsidy, price).length <= 1 ||
                        checkDisableByAgeType(price.ageType) ||
                        checkDisableOptionalCouponNum(price)
                      "
                    />
                    <span class="ml-2 self-center">枚</span>
                  </div>
                </div>
              </div>
            </div>
            <template slot="extra">
              {{ getTotalUseCnt(subsidy) | formatInteger }}
            </template>
          </a-collapse-panel>
        </a-collapse>
      </div>

      <div
        class="flex flex-col alert-warning"
        v-show="couponWarnings && couponWarnings.length"
      >
        <span v-for="(msg, idx) in couponWarnings" :key="`coupon-warning-${idx}`">
          {{ msg }}
        </span>
      </div>

      <div class="c-spinner">
        <a-spin :spinning="loading" />
      </div>
    </div>

    <!-- 任意クーポンがある場合 -->
    <div v-if="subsidyData.length > forceUseSubsidys.length && canUseOptional === true" class="coupon-popup-footer" style="margin-top: 10px">
      <Button text="閉じる" outline @click="handleCancel" />
      <Button text="確定" type="dark" @click="handleOk" />
    </div>
    <!-- 強制クーポンのみの場合 -->
    <div v-else class="coupon-popup-footer" style="margin-top: 10px">
      <Button text="閉じる" outline @click="handleCancel" />
      <Button v-if="publicStayMode" text="確定" type="dark" @click="handleOk" />
    </div>
  </div>
</template>

<script>
import { bus } from '@/main'
import { cloneDeep, get } from 'lodash'
import { COUPON_AGE_TYPE, COUPON_PRICE_TYPE } from '@/constants/coupon'
import moment from 'moment'

import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'
import couponMixin from '@/mixins/coupon.js'

import SubsidyDetail from '../SubsidyDetail'

export default {
  name: 'ApplyCoupon',
  mixins: [func_utils, plan_utils, couponMixin],
  components: {
    SubsidyDetail
  },
  props: [
    'visible',
    'planData',
    'stayDay',
    'stayNights',
    'stayRooms',
    'vacancyCalendar',
    'source',
    'acptDtlNo',
    'publicStayMode',
    'roomDetails'
  ],
  data() {
    return {
      SOURCE_AVAILABLE: {
        order_confirmation: 'order_confirmation'
      },
      loading: false,
      dateFormat: 'YYYY/MM/DD',
      datetimeFormat: 'YYYY-MM-DD HH:mm:ss',
      couponActiveKey: null,
      groupCouponActiveKey: null,
      planDetail: null,
      memberAdults: 1,
      visitorAdults: 0,

      couponOption: 0,
      // maxStayCapacity: null, // 未使用
      // minStayCapacity: null, // 未使用
      // limitRooms: 0, // 未使用
      // outstockDayMap: {}, // 未使用
      // selectedDaysInfo: [], // 未使用
      // showMemberChildren: false, // 未使用
      // showVisitorChildren: false, // 未使用
      memberChldDetails: {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      },
      visitorChldDetails: {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      },
      // relationshipData: [], // 未使用
      forceUseSubsidys: [],
      subsidyData: [],
      subsidyDetailList: [],
      groupSubsidyDetailList: [],
      remainingSubsidys: [],
      // bkRemainingSubsidys: [], // 未使用
      totalForceUseDiscount: 0,
      totalAppliedCouponPrice: 0,
      totalDiscountAmount: 0,
      couponWarnings: [],
      couponVerified: undefined,
      personAccompanyFlg: false,
      // reload: false, // 未使用
      stayRoomDetails: [],
      stayNightDetails: [],
      reRenderCouponList: false,
      canUseOptional: true,
      visibleCoupons: {}
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    appliedCouponData() {
      const stateCustomerPlan = cloneDeep(this.$store.getters.customerPlan)
      return {
        memberAdults: stateCustomerPlan.memberAdults,
        visitorAdults: stateCustomerPlan.visitorAdults,
        memberChldDetails: stateCustomerPlan.memberChldDetails,
        visitorChldDetails: stateCustomerPlan.visitorChldDetails,
        couponOption: get(stateCustomerPlan, 'couponPlanData.couponOption')
      }
    },
    bsAppState() {
      return this.$store.getters.bs_app
    },
    totalMemberCnt() {
      return this.memberAdults + this.totalChldMemberCnt
    },
    totalVisitorCnt() {
      return this.visitorAdults + this.totalChldVisitorCnt
    },
    totalChldMemberCnt() {
      return Object.keys(this.memberChldDetails)
        .map((key) => this.memberChldDetails[key])
        .reduce((a, b) => a + b, 0)
    },
    totalChldVisitorCnt() {
      return Object.keys(this.visitorChldDetails)
        .map((key) => this.visitorChldDetails[key])
        .reduce((a, b) => a + b, 0)
    },
    // 未使用
    // displayCouponOption() {
    //   const forced = this.CONST_DATA.USED_FORM_DIV.FORCED;
    //   return (
    //     this.remainingSubsidys.filter((c) => c.availableData.usedFormDiv !== forced)
    //       .length && this.canUseOptional === true
    //   )
    // }
  },
  created() {
    this.dump('created ApplyCoupon')
    this.dump('props', this.$props)

    if (this.planData) {
      this.planDetail = cloneDeep(this.planData)
      // this.maxStayCapacity = get(this.planDetail, 'roomBasicInfo.maxStayCapacity', null)
      // this.minStayCapacity = get(this.planDetail, 'roomBasicInfo.minStayCapacity', null)
      // this.setLimitRoomCapacity()
      this.markOutstockDays()
      this.$_couponMixin_updateSelectedDaysInfo(
        this.stayDay,
        this.stayNights,
        this.vacancyCalendar
      )
    }
    this.dump('this.applyCouponData', this.appliedCouponData)
    if (this.appliedCouponData) {
      const appliedCouponData = cloneDeep(this.appliedCouponData)
      this.memberAdults = appliedCouponData.memberAdults
      this.memberChldDetails = appliedCouponData.memberChldDetails
      this.visitorAdults = appliedCouponData.visitorAdults
      this.visitorChldDetails = appliedCouponData.visitorChldDetails
      this.couponOption = appliedCouponData.couponOption || 0
    }
    if (!this.stayRoomDetails || this?.stayRoomDetails?.length === 0) {
      this.dump('this.stayRoomDetailsがないため、外部指定の部屋情報を使用します。')
      this.stayRoomDetails = cloneDeep(this.roomDetails)
    } else if (this.bsAppState.bs_app_02_001) {
      this.stayRoomDetails =
        get(this.bsAppState.bs_app_02_001, 'stayRoomDetails', null) || []
      this.stayRoomDetails.forEach((room) => {
        room.relationships.forEach((r) => {
          // check personAccompanyFlg
          if (+get(r, 'relationship.relationshipId') === 0) {
            this.personAccompanyFlg = true
          }
        })
      })
    }

    this.loading = true
    this.getSubsidyCoupons(() => {
      // CHECK VISIBLE COUPONS
      this.subsidyData.forEach((subsidy) => {
        if (this.checkVisibleCoupon(subsidy)) {
          this.visibleCoupons[subsidy.availableData.subsidyId] = true
        } else {
          this.visibleCoupons[subsidy.availableData.subsidyId] = false
        }
      })

      this.loading = false
      // this.dump('this.visibleCoupons', this.visibleCoupons)
      // this.dump('getSubsidyCoupons callback stayNights', this.stayNights)
      // this.dump('getSubsidyCoupons callback stayRoomDetails', this.stayRoomDetails)
      // this.dump('getSubsidyCoupons callback subsidyData', this.subsidyData)
      this.stayNightDetails = this.$_couponMixin_convertStayNightDetails(
        this.stayNights,
        this.stayRoomDetails,
        this.subsidyData
      )
      this.dump('getSubsidyCoupons callback stayNightDetails', this.stayNightDetails)

      if (this.couponOption === 0) {
        this.useFullCoupon()
      } else if (this.couponOption === 1) {
        this.usePathOfCoupon()
      } else {
        this.notUseCoupon()
      }
      this.changeCouponOption();
      this.dump('getSubsidyCoupons callback afterChangeCouponOption', this.stayNightDetails)

    })

    bus.$off('resetCouponScreen').$on('resetCouponScreen', () => {
      this.couponOption = 0
      this.useFullCoupon()
    })
  },
  watch: {
    visible(val) {
      if (val && !this.couponOption) {
        this.couponOption = 0
      }
      this.changeCouponOption();
    },
    planData(val) {
      this.planDetail = cloneDeep(val)
      // this.maxStayCapacity = get(this.planDetail, 'roomBasicInfo.maxStayCapacity', null)
      // this.minStayCapacity = get(this.planDetail, 'roomBasicInfo.minStayCapacity', null)
      // this.setLimitRoomCapacity()
      this.markOutstockDays()
      this.$_couponMixin_updateSelectedDaysInfo(
        this.stayDay,
        this.stayNights,
        this.vacancyCalendar
      )
    }
  },
  methods: {
    dev(msg){
      // alert(msg)
      // console.log(msg)
    },
    dump(...args){
      // console.log(...args)
    },
    changeCouponOption() {
      if(+this.couponOption === 0) {
        this.couponOption = 1;
        this.onChangeCouponOption()
      }
    },
    get,
    getCouponDescrition(subsidy) {
      let couponDesc = []

      // 利用制限期間[01:年]の場合
      if (get(subsidy, 'availableData.usedLimTerm') == '01') {
        couponDesc.push('上記適用期間内での制限適用となります');
      }
      // 利用制限期間[02:月]の場合
      if (get(subsidy, 'availableData.usedLimTerm') == '02') {
        couponDesc.push('月の利用制限となります');
      }

      if (this.getRequestTypeCoupon(subsidy) == '01') {
        if (this.isShowParsonalUsedMaxCnt(subsidy)) {
          const mes = `保有枚数${this.$filters.formatInteger(subsidy.availableRemainingCount)}/
          ${this.$filters.formatInteger(get(subsidy, 'availableData.parsonalUsedMaxCnt'))}
          枚（利用可能残額${this.$filters.formatInteger(get(subsidy, 'availableRemainingAmount'))}/
          ${this.$filters.formatInteger(
            get(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
          )}
          円）までご利用いただけます。`
          couponDesc.push(mes)
        }
        if (
          get(subsidy, 'availableData.parsonalUsedMaxCnt') > 0 &&
          !get(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
        ) {
          const mes = `保有枚数${this.$filters.formatInteger(subsidy.availableRemainingCount)}/
          ${this.$filters.formatInteger(get(subsidy, 'availableData.parsonalUsedMaxCnt'))}
          枚までご利用いただけます。`
          couponDesc.push(mes)
        }
        if (
          !get(subsidy, 'availableData.parsonalUsedMaxCnt') &&
          get(subsidy, 'availableData.parsonalUsedMaxTotalAmt') > 0
        ) {
          const mes = `利用可能残額${this.$filters.formatInteger(
            subsidy.availableRemainingAmount
          )}/
          ${this.$filters.formatInteger(
            get(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
          )}
          円までご利用いただけます。`
          couponDesc.push(mes)
        }
      }

      // 健保補助金の場合
      if (this.getRequestTypeCoupon(subsidy) == '02') {

        // 上限枚数が1枚以上設定されている場合
        if (this.isShowUsedMaxCntInsurance01(subsidy) > 0 && !this.isShowUsedMaxTotalAmt(subsidy)) {
          const mes = `
            ${this.$filters.formatInteger(get(subsidy, 'availableData.applicableDegreeCnt'))}
            親等までを対象者として、1対象者あたり最大
            ${this.$filters.formatInteger(get(subsidy, 'availableData.parsonalUsedMaxCnt'))}枚までご利用いただけます。
          `
          couponDesc.push(mes)
        }

        // 上限金額が1円以上設定されている場合
        if (this.isShowUsedMaxTotalAmt(subsidy) > 0 && !this.isShowUsedMaxCntInsurance01(subsidy) ) {
          const mes = `
            ${this.$filters.formatInteger(get(subsidy, 'availableData.applicableDegreeCnt'))}
            親等までを対象者として、1対象者あたり最大
            ${this.$filters.formatInteger(get(subsidy, 'availableData.parsonalUsedMaxTotalAmt'))}円までご利用いただけます。
          `
          couponDesc.push(mes)
        }

        // 上限金額・上限枚数が1円・1枚以上設定されている場合
        if (this.isShowUsedMaxTotalAmt(subsidy) > 0 && this.isShowUsedMaxCntInsurance01(subsidy) > 0 ) {
          const mes = `
            ${this.$filters.formatInteger(get(subsidy, 'availableData.applicableDegreeCnt'))}親等までを対象者として、1対象者あたり最大
            ${this.$filters.formatInteger(get(subsidy, 'availableData.parsonalUsedMaxCnt'))}枚、
            ${this.$filters.formatInteger(get(subsidy, 'availableData.parsonalUsedMaxTotalAmt'))}円までご利用いただけます。
          `
          couponDesc.push(mes)
        }

        // 上限金額が０円（使い切った）または存在しない場合（未設定）
        // かつ
        // 保有金額が1円以上設定されている場合
        if (
          (this.isShowUsedMaxTotalAmt(subsidy) == 0 || !this.isShowUsedMaxTotalAmt(subsidy)) &&
          subsidy.availableRemainingAmount > 0
        ) {
          const mes = `第${this.$filters.formatInteger(
            get(subsidy, 'availableData.applicableDegreeCnt')
          )}
          親等までを対象者として、1対象者あたり最大
          ${this.$filters.formatInteger(get(subsidy.availableRemainingAmount))}
          円までご利用いただけます`
          couponDesc.push(mes)
        }

        // 残金額
        if (this.isShowRemainingAmtCntLabelInsur(subsidy)) {
          const mes = `下記は、過去に利用した対象者の保有枚数（残金額）を表示しています。
          未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
          ${this.$filters.formatInteger(
            get(subsidy, 'scrennDisplayItemList.remainingAmountLabel')
          )}`
          couponDesc.push(mes)
        }

        // 残枚数
        if (get(subsidy, 'scrennDisplayItemList.remainingCountLabel')) {
          const mes = `下記は、過去に利用した対象者の保有枚数を表示しています。
          未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
          ${this.$filters.formatInteger(
            get(subsidy, 'scrennDisplayItemList.remainingCountLabel')
          )}`
          couponDesc.push(mes)
        }
      }

      // 利用上限総額（数）
      // usedLimUnit(利用制限単位)による条件分岐は不要。
      // usedLimUnitが01(個人)の場合は、usedMaxCnt・usedMaxTotalAmtはセットされない
      if (get(subsidy, 'availableData.usedMaxCnt')) {
        couponDesc.push(`所属団体様内で先着${this.$filters.formatInteger(get(subsidy, 'availableData.usedMaxCnt'))}枚まで`)
      }
      if (get(subsidy, 'availableData.usedMaxTotalAmt')) {
        couponDesc.push('※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。')
      }
      if (get(subsidy, 'availableData.minChargeAmt') === 1) {
        couponDesc.push('必ず自己負担が必要になります。')
      }
      if (get(subsidy, 'availableData.minChargeAmt') > 1) {
        const mes = `${this.$filters.formatInteger(
          get(subsidy, 'availableData.minChargeAmt')
        )}
      円以上のご負担が必要となります。`
        couponDesc.push(mes)
      }
      if (
        !get(subsidy, 'availableData.minChargeAmt') &&
        get(subsidy, 'availableData.costUnderChargeableFlg') == '0'
      ) {
        couponDesc.push('利用金額が補助金額に満たない場合は利用不可')
      }
      if (get(subsidy, 'availableData.minTgtAge')) {
        const mes = `${this.$filters.formatInteger(
          get(subsidy, 'availableData.minTgtAge')
        )}歳以上が対象`
        couponDesc.push(mes)
      }
      if (get(subsidy, 'availableData.personAccompanyFlg') === '1') {
        couponDesc.push('家族会員のみでの利用不可')
      }
      if (get(subsidy, 'availableData.multipleUnusableFlg') === '0') {
        couponDesc.push('併用可')
      }
      if (get(subsidy, 'availableData.multipleUnusableFlg') === '1') {
        couponDesc.push('併用不可')
      }
      if (get(subsidy, 'availableData.usedFormDiv') === this.CONST_DATA.USED_FORM_DIV.FORCED) {
        couponDesc.push('対象メニューの申込で自動で利用できます。')
      }
      if (get(subsidy, 'availableData.usedFormDiv') === this.CONST_DATA.USED_FORM_DIV.ANY) {
        couponDesc.push('利用申請があった場合のみ利用できます。')
      }

      return couponDesc.join('/')
    },
    getGroupCouponDescrition(subsidyGroup) {
      let groupCouponDesc = []

      // 利用制限期間
      if (subsidyGroup.usedLimTerm === "01") {
        groupCouponDesc.push("上記適用期間内での制限適用となります");
      } else {
        groupCouponDesc.push("月の利用制限となります");
      }

      // 利用上限総額（数）
      if (
        subsidyGroup.usedMaxCnt > 0 &&
        subsidyGroup.usedMaxTotalAmt > 0
      ) {
        groupCouponDesc.push(`所属団体様内で先着${this.$filters.formatInteger(subsidyGroup.usedMaxCnt)}枚まで/※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。`);
      } else if (
        subsidyGroup.usedMaxCnt > 0 &&
        !subsidyGroup.usedMaxTotalAmt
      ) {
        groupCouponDesc.push(`所属団体様内で先着${this.$filters.formatInteger(subsidyGroup.usedMaxCnt)}枚まで`);
      } else if (
        !subsidyGroup.usedMaxCnt &&
        subsidyGroup.usedMaxTotalAmt > 0
      ) {
        groupCouponDesc.push("※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。");
      }

      return groupCouponDesc.join('/');
    },

    isShowParsonalUsedMaxCnt(subsidy) {
      return (
        subsidy.availableData.parsonalUsedMaxCnt > 0 &&
        subsidy.availableData.parsonalUsedMaxTotalAmt > 0
      )
    },
    isShowUsedMaxCntInsurance01(subsidy) {
      return get(subsidy, 'availableData.parsonalUsedMaxCnt')
    },
    isShowUsedMaxTotalAmt(subsidy) {
      return get(subsidy, 'availableData.parsonalUsedMaxTotalAmt', null)
    },
    isShowRemainingAmtCntLabelInsur(subsidy) {
      return (
        get(subsidy, 'scrennDisplayItemList.remainingCountLabel') &&
        get(subsidy, 'scrennDisplayItemList.remainingAmountLabel')
      )
    },
    getRequestTypeCoupon(coupon) {
      return get(coupon, 'availableData.requestType')
    },
    checkVisibleCoupon(subsidy) {
      const coupon = JSON.parse(JSON.stringify(subsidy))

      const forced = this.CONST_DATA.USED_FORM_DIV.FORCED;
      return coupon.availableData.usedFormDiv !== forced;
    },
    getSubsidyOptions(day, subsidy, price) {
      let count = null
      const remainingCount = subsidy.availableRemainingCount
      // max selectable: peoples & nights
      const limitCnt = this.totalMemberCnt * this.stayNights
      if (subsidy.availableRemainingCount === null || (count !== null && count > limitCnt)) {
        count = limitCnt
      }
      const _thisSelectUseCnt = price.selectUseCnt || 0
      // CHECK RELATIONSHIP
      const applicableDegreeCnt = subsidy.availableData.applicableDegreeCnt
      const minTgtAge = subsidy.availableData.minTgtAge
      if (subsidy.availableData.requestType === '01') {
        // DOANH NGHIỆP
        if (price.priceType === COUPON_PRICE_TYPE.OWNER) {
          // Chính chủ
          count = day.rooms
            .map((r) => {
              const ownCnt = r.relationships
                .filter(
                  (rela) =>
                    !rela.isVisitor &&
                    rela.relationshipCode === 'C-0-0' &&
                    rela.relationshipCode !== "C-205-9" &&
                    (!rela.isChildren ||
                      (rela.isChildren &&
                        (!minTgtAge || (minTgtAge && +rela.age >= +minTgtAge))))
                )
                .map(() => 1)
                .reduce((a, b) => a + b, 0)
              return ownCnt
            })
            .reduce((a, b) => a + b, 0)
        } else if (price.priceType === COUPON_PRICE_TYPE.FAMILY) {
          // Gia đình
          count = day.rooms
            .map((r) => {
              const famalyCnt = r.relationships
                .filter(
                  (rela) =>
                    !rela.isVisitor &&
                    rela.relationshipCode !== 'C-0-0' &&
                    rela.relationshipCode !== "C-205-9" &&
                    (applicableDegreeCnt === null ||
                      +rela.relationship.relationshipLevel <= applicableDegreeCnt) &&
                    (!rela.isChildren ||
                      (rela.isChildren &&
                        (!minTgtAge || (minTgtAge && +rela.age >= +minTgtAge))))
                )
                .map(() => 1)
                .reduce((a, b) => a + b, 0)
              return famalyCnt
            })
            .reduce((a, b) => a + b, 0)
        } else {
          // Đồng giá
          count = day.rooms
            .map((r) => {
              const memberCnt = r.relationships
                .filter(
                  (rela) =>
                    !rela.isVisitor &&
                    rela.relationshipCode !== "C-205-9" &&
                    (applicableDegreeCnt === null ||
                      +rela.relationship.relationshipLevel <= applicableDegreeCnt) &&
                    (!rela.isChildren ||
                      (rela.isChildren &&
                        (!minTgtAge || (minTgtAge && +rela.age >= +minTgtAge))))
                )
                .map(() => 1)
                .reduce((a, b) => a + b, 0)
              return memberCnt
            })
            .reduce((a, b) => a + b, 0)
        }
      } else {
        // BẢO HIỂM
        let x = 0
        let found = false
        day.rooms.forEach((room) => {
          room.relationships
            .filter((r) => r.relationshipCode === price.relationshipCode)
            .forEach((rel) => {
              const relationshipLevel = +rel.relationship.relationshipLevel
              // CHÍNH CHỦ
              if (rel.relationship.relationshipId === '0') {
                let flg = false
                // NGƯỜI LỚN
                if (
                  !rel.isChildren &&
                  price.priceType === COUPON_PRICE_TYPE.OWNER &&
                  price.ageType === COUPON_AGE_TYPE.ADULT
                ) {
                  x += 1
                  flg = true
                  found = true
                } else if (
                  rel.isChildren &&
                  price.priceType === COUPON_PRICE_TYPE.OWNER &&
                  price.ageType === COUPON_AGE_TYPE.CHILDREN
                ) {
                  // TRẺ EM
                  if (!minTgtAge || (minTgtAge && +rel.age >= +minTgtAge)) {
                    x += 1
                  }
                  flg = true
                  found = true
                }
                if (
                  !flg &&
                  price.priceType === COUPON_PRICE_TYPE.OWNER &&
                  price.ageType === COUPON_AGE_TYPE.BOLT
                ) {
                  // ĐỒNG GIÁ
                  x += 1
                  found = true
                }
              } else if (
                applicableDegreeCnt === null ||
                relationshipLevel <= applicableDegreeCnt
              ) {
                // GIA ĐÌNH
                let flg = false
                // NGƯỜI LỚN
                if (
                  !rel.isChildren &&
                  price.priceType === COUPON_PRICE_TYPE.FAMILY &&
                  price.ageType === COUPON_AGE_TYPE.ADULT
                ) {
                  x += 1
                  flg = true
                  found = true
                } else if (
                  rel.isChildren &&
                  price.priceType === COUPON_PRICE_TYPE.FAMILY &&
                  price.ageType === COUPON_AGE_TYPE.CHILDREN
                ) {
                  // TRẺ EM
                  if (!minTgtAge || (minTgtAge && +rel.age >= +minTgtAge)) {
                    x += 1
                  }
                  flg = true
                  found = true
                }
                if (
                  !flg &&
                  price.priceType === COUPON_PRICE_TYPE.FAMILY &&
                  price.ageType === COUPON_AGE_TYPE.BOLT
                ) {
                  // ĐỒNG GIÁ
                  x += 1
                  found = true
                }
              }
              // ĐỒNG GIÁ
              if (
                !found &&
                !rel.isChildren &&
                price.priceType === COUPON_PRICE_TYPE.BOLT &&
                price.ageType === COUPON_AGE_TYPE.ADULT &&
                (applicableDegreeCnt === null || relationshipLevel <= applicableDegreeCnt)
              ) {
                x += 1
              } else if (
                !found &&
                rel.isChildren &&
                price.priceType === COUPON_PRICE_TYPE.BOLT &&
                price.ageType === COUPON_AGE_TYPE.CHILDREN &&
                (applicableDegreeCnt === null ||
                  relationshipLevel <= applicableDegreeCnt) &&
                (!minTgtAge || (minTgtAge && +rel.age >= +minTgtAge))
              ) {
                x += 1
              } else if (
                !found &&
                !rel.isChildren &&
                price.priceType === COUPON_PRICE_TYPE.BOLT &&
                price.ageType === COUPON_AGE_TYPE.BOLT &&
                (applicableDegreeCnt === null || relationshipLevel <= applicableDegreeCnt)
              ) {
                x += 1
              } else if (
                !found &&
                rel.isChildren &&
                price.priceType === COUPON_PRICE_TYPE.BOLT &&
                price.ageType === COUPON_AGE_TYPE.BOLT &&
                (applicableDegreeCnt === null ||
                  relationshipLevel <= applicableDegreeCnt) &&
                (!minTgtAge || (minTgtAge && +rel.age >= +minTgtAge))
              ) {
                x += 1
              }
            })
        })
        count = x
      }

      // CHECK REMAINING
      if (remainingCount !== null && remainingCount < count) {
        count = remainingCount
      }

      // MAX - SELECTED
      let selectedCnt = 0
      this.stayNightDetails
        .filter((night) => night.stayDay === day.stayDay)
        .forEach((night) => {
          night.coupons.forEach((coupon) => {
            if (coupon.availableData.requestType === '01') {
              // DOANH NGHIỆP
              coupon.availableData.priceList.forEach((p) => {
                const isSame = this.isSameAgeType(price, p)
                if (isSame) {
                  selectedCnt += +p.selectUseCnt
                }
              })
            } else {
              coupon.availableData.priceList.forEach((p) => {
                if (
                  p.subsidyPriceId === price.subsidyPriceId &&
                  p.relationshipCode === price.relationshipCode
                ) {
                  selectedCnt += +p.selectUseCnt
                }
              })
            }
          })
        })

      if (selectedCnt) {
        count -= selectedCnt
      }
      count += _thisSelectUseCnt

      const options = []
      for (let i = 0; i <= count; i++) {
        options.push({
          label: String(i),
          value: i
        })
      }
      return options
    },
    isSameAgeType(source, target) {
      if (
        source.subsidyDetailId === target.subsidyDetailId &&
        source.priceType === target.priceType
      ) {
        return true
      }
      if (
        source.subsidyDetailId === target.subsidyDetailId &&
        (source.priceType === COUPON_PRICE_TYPE.BOLT ||
          target.priceType === COUPON_PRICE_TYPE.BOLT)
      ) {
        return true
      }
      return false
    },
    getTotalUseCnt(subsidy) {
      if (this.couponOption === 1) {
        return subsidy.availableData.priceList
          .map((r) => r.selectUseCnt || 0)
          .reduce((a, b) => a + b, 0)
      }
      return subsidy.availableData.priceList
        .map((r) => r.useCnt || 0)
        .reduce((a, b) => a + b, 0)
    },
    async getSubsidyCoupons(callback = null) {
      const today = moment()
      // stayDay
      const checkInDay = moment(this.stayDay)
      const checkOutDay =
        this.stayNights >= 0
          ? checkInDay.clone().add(this.stayNights, 'days')
          : checkInDay.clone().add(1, 'days')
      let subsidyAvailables = await this.$repositories('coupon')
        .getSubsidyCouponList({
          reserveDateFrom: today.format('YYYY-MM-DD'),
          reserveDateTo: today.format('YYYY-MM-DD'),
          useDateFrom: checkInDay.format('YYYY-MM-DD'),
          useDateTo: checkOutDay.add(-1, 'days').format('YYYY-MM-DD'),
          personAccompanyFlag: this.personAccompanyFlag || null,
          displayDiv: '2'
        })
        .catch((error) => {
          return error
        })
      if (!Array.isArray(subsidyAvailables)) {
        subsidyAvailables = []
      }
      this.dump('getSubsidyCoupons subsidyAvailables 1', subsidyAvailables)
      subsidyAvailables = subsidyAvailables.filter(
        (s) =>
          moment(s.availableData.receptionDateFrom).isSameOrBefore(today, 'day') &&
          moment(s.availableData.receptionDateTo).isSameOrAfter(today, 'day')
      )
      this.dump('getSubsidyCoupons subsidyAvailables 2', subsidyAvailables)
      if (subsidyAvailables.length > 0) {
        const subsidyIds = subsidyAvailables
          .map((s) => s.availableData.subsidyId)
          .join('-')
        const stationMapping = await this.$repositories('coupon')
          .getStationMapping({
            id: subsidyIds, // 0: subsidy, 1: cafe
            targetType: 0, // 0: subsidy, 1: cafe
            catLrgClassCd: get(
              this.planDetail,
              'menuInformation.categoryInfomation.catLrgClassCd',
              ''
            ),
            catMidClassCd: get(
              this.planDetail,
              'menuInformation.categoryInfomation.catMidClassCd',
              ''
            ),
            catSmlClassCd: get(
              this.planDetail,
              'menuInformation.categoryInfomation.catSmlClassCd',
              ''
            ),
            menuNo: get(this.planDetail, 'menuInformation.menuNo', ''),
            // planId: get(this.planDetail, 'planBasicInfo.planId', ''),
            planId: '0',
            areaLrgClassCd: get(
              this.planDetail,
              'menuInformation.areaInfomation.areaLrgClassCd',
              ''
            ),
            areaMidClassCd: get(
              this.planDetail,
              'menuInformation.areaInfomation.areaMidClassCd',
              ''
            ),
            areaSmlClassCd: get(
              this.planDetail,
              'menuInformation.areaInfomation.areaSmlClassCd',
              ''
            ),
            areaDtlClassCd: get(
              this.planDetail,
              'menuInformation.areaInfomation.areaDtlClassCd',
              ''
            ),
            // receivableFlag: get(this.planDetail, 'planUsage.usageDetail.receivableFlag', ''),
            // ticketExclusionFlag: get(
            //   this.planDetail,
            //   'planUsage.usageDetail.ticketExclusionFlag',
            //   ''
            // ),
            // buppanExclusionFlag: get(
            //   this.planDetail,
            //   'planUsage.usageDetail.buppanExclusionFlag',
            //   ''
            // ),
            // famiExclusionFlag: get(
            //   this.planDetail,
            //   'planUsage.usageDetail.famiExclusionFlag',
            //   ''
            // ),
            receivableFlag: '1',
            ticketExclusionFlag: '1',
            buppanExclusionFlag: '1',
            famiExclusionFlag: '1',
          })
          .catch((error) => {
            return error
          })

        if (stationMapping && stationMapping.bsSubsidyMappingArray) {
          const bsSubsidyIdMappings = stationMapping.bsSubsidyMappingArray.map(
            (e) => e.subsidyId
          )
          subsidyAvailables = subsidyAvailables.filter((c) =>
            bsSubsidyIdMappings.includes(c.availableData.subsidyId)
          )
        } else {
          // ステマAPI実行時にエラーが発生した場合、補助金情報を返さない #77940
          subsidyAvailables = []
        }
        
        this.dump('getSubsidyCoupons subsidyAvailables 3', subsidyAvailables)
        // ĐẶT TRƯỚC 7 NGÀY ĐỐI VỚI COUPON BẢO HIỂM
        if (!moment().add(7, 'days').isSameOrBefore(this.stayDay, 'day')) {
          subsidyAvailables = subsidyAvailables.filter(
            (s) => s.availableData.fiveDaysAgoControlFlg === "0"
          )
        }

        // プラン詳細画面同様、グループ補助金が先表示となるようソート
        // グループ補助金はグループidごとに昇順でソート(ソート順で要望は決まってないため昇順に設定)
        subsidyAvailables.sort(
          (prev, next) => {
            const prevGroupId = prev.availableData.groupInfo?.groupId;
            const nextGroupId = next.availableData.groupInfo?.groupId;
            if(!prevGroupId) return 1;
            if(!nextGroupId) return -1;
            if(prevGroupId === nextGroupId) return 0;
            return prevGroupId > nextGroupId ? 1 : -1;
          }
        )

        this.subsidyData = subsidyAvailables
          .filter(
            (c) =>
              c.availableData.useStopFlg === '0' &&
              c.availableData.subsidyType === '01' &&
              (c.availableRemainingCount === null || +c.availableRemainingCount > 0)
          )
          .map((e) => {
            e.useCnt = 0
            return e
          })
        this.dump('getSubsidyCoupons this.subsidyData(補助金データ)', this.subsidyData)
        const forced = this.CONST_DATA.USED_FORM_DIV.FORCED;
        this.forceUseSubsidys = cloneDeep(
          this.subsidyData.filter((c) => c.availableData.usedFormDiv === forced)
        )
        this.dump('getSubsidyCoupons this.forceUseSubsidys(強制補助金データ)', this.forceUseSubsidys)
        this.remainingSubsidys = cloneDeep(this.subsidyData)

        // 補助金詳細表示処理のため、グループ補助金とそれ以外で分類
        this.subsidyDetailList = cloneDeep(
          this.subsidyData.filter(
            (c) => c.availableData.groupInfo == null && c.availableData.usedFormDiv !== forced
          )
        )
        const groupSubsidyList = cloneDeep(
          this.subsidyData.filter(
            (c) => c.availableData.groupInfo != null && c.availableData.usedFormDiv !== forced
          )
        )

        // グループ親補助金情報のみ抽出
        this.groupSubsidyDetailList = groupSubsidyList.map((c) => {
          return {
            ...c.availableData.groupInfo,
            groupRemainingCountLabel: c.scrennDisplayItemList.groupRemainingCountLabel.value,
            groupRemainingAmountLabel: c.scrennDisplayItemList.groupRemainingAmountLabel.value,
            usedLimUnit: c.availableData.usedLimUnit  // プラン詳細に倣いグループ単位で共通の前提
          }
        })
        // グループ親補助金情報の重複削除
        this.groupSubsidyDetailList = this.groupSubsidyDetailList.filter(
          (element, index, group) => group.findIndex((e) => e.groupId === element.groupId) === index
        )
        // 補助金詳細表示処理のため、グループ親補助金情報に子補助金情報を紐づけ
        this.groupSubsidyDetailList.forEach(
          (group) => {
            group.subsidyDetailList = [];
            group.subsidyDetailList.push(
              ...groupSubsidyList.filter((c) => c.availableData.groupInfo.groupId === group.groupId)
            )
          }
        )
      }

      if (callback) {
        callback()
      }
    },
    onChangeCouponOption() {
      this.couponWarnings = []
      switch (this.couponOption) {
        case 0:
          this.useFullCoupon()
          break
        case 1:
          this.couponVerified = false
          // this.remainingSubsidys = cloneDeep(
          //   this.remainingSubsidys.map((s) => {
          //     // s.useCnt = 0
          //     s.selectUseCnt = s.useCnt
          //     return s
          //   })
          // )
          // this.stayNightDetails = this.$_couponMixin_convertStayNightDetails(
          //   this.stayNights,
          //   this.stayRoomDetails,
          //   this.subsidyData
          // )
          this.stayNightDetails = this.stayNightDetails.map((night) => {
            night.coupons = night.coupons.map((coupon) => {
              coupon.availableData.priceList = coupon.availableData.priceList.map(
                (price) => {
                  price.selectUseCnt = price.useCnt
                  price.remaining = price.selectUseCnt || 0
                  return price
                }
              )
              return coupon
            })
            return night
          })
          this.usePathOfCoupon()
          break
        case 2:
          this.remainingSubsidys = cloneDeep(
            this.remainingSubsidys.map((s) => {
              s.useCnt = 0
              return s
            })
          )
          this.notUseCoupon()
          break
        default:
          break
      }
    },
    onChangeCouponUseCnt() {
      if (this.couponOption === 1) {
        this.stayNightDetails = this.stayNightDetails.map((night) => {
          night.coupons = night.coupons.map((coupon) => {
            coupon.availableData.priceList = coupon.availableData.priceList.map(
              (price) => {
                price.remaining = price.selectUseCnt || 0
                return price
              }
            )
            return coupon
          })
          return night
        })
        const result = this.usePathOfCoupon()
        if (result && result.missUsePlan) {
          // TOAST MESSAGE
          this.$toasted.error('申込可能な数量を超えています。')
        }
      }
      this.$nextTick(() => {
        this.reRenderCouponList = !this.reRenderCouponList
      })
    },
    // setLimitRoomCapacity() {
    //   if (get(this.planDetail, 'menuInformation.extSystemCd') === 'RakutenT') {
    //     this.limitRooms = 10
    //   } else if (get(this.planDetail, 'menuInformation.extSystemCd') === 'ToyokoInn') {
    //     this.limitRooms = 4
    //   } else {
    //     this.limitRooms = 19
    //   }
    //   this.limitPeoples = 19
    // },
    async checkSubsidy() {
      let totalUseCnt = 0;
      this.stayNightDetails.forEach(stayNightDetail => {
        const useCnt = stayNightDetail.coupons
          .map(coupon => this.getTotalUseCnt(coupon))
          .reduce((a, b) => a + b, 0);
        totalUseCnt += useCnt;
      })
      if (totalUseCnt === 0) {
        // Show MESSAGE
        this.$toasted.error(
          '補助金が選択されておりません。'
        )
        return;
      }
      const profileMe = this.$store.getters['auth/get'].profileMe
      this.couponWarnings = []
      // call API check apply Coupon
      const validateCouponData = {
        reservationInfo: [],
        applyTargetAmount: this.stayNightDetails[0].rooms
          .map((room) => room.roomAmount)
          .reduce((a, b) => a + b, 0)
      }

      this.stayNightDetails.forEach((night) => {
        const stayNight = moment(night.stayDay).clone().format(this.datetimeFormat);
        night.rooms.forEach((room) => {
          room.relationships.forEach((rel) => {
            rel.appliedCoupons.forEach((applied) => {
              let exist = false
              validateCouponData.reservationInfo.forEach((n) => {
                if (
                  n.subsidyId === applied.availableData.subsidyId &&
                  n.relationshipCd === rel.relationship.relationshipId &&
                  n.useScheduleDateTime === stayNight
                ) {
                  exist = true
                }
              })
              if (!exist) {
                validateCouponData.reservationInfo.push({
                  subsidyId: applied.availableData.subsidyId,
                  customerNo: get(this.userInfo, 'ssoCustomerNo', null),
                  subsidyDetailId: applied.availableData.subsidyDetailId,
                  subsidyPriceId: get(applied, 'applyPrice.subsidyPriceId', null),
                  personAccompanyFlag: applied.availableData.personAccompanyFlg,
                  minimamTargetAge: rel.age,
                  degreeCount: get(rel, 'relationship.relationshipLevel', ''),
                  useScheduleDateTime: stayNight,
                  acptDtlNo: '',
                  company_cd: get(profileMe, 'data.companyCd', null), // companyCd
                  subscription_id: get(this.userInfo, 'ssoSubscriptionId', null),
                  relationshipCd: rel.relationship.relationshipId,
                  couponId: get(applied, 'availableData.couponInfo[0].couponId', null), // 63752 どのcouponIdを指定してもよいため、最初のcouponIdをリクエストボディに含める
                  groupId: get(applied, 'availableData.groupInfo.groupId', null)
                })
              }
            })
          })
        })
      })

      this.$loading.show()
      this.$repositories('coupon')
        .validateUseCoupon(validateCouponData)
        .then(
          () => {
            this.$loading.hide()
            this.couponVerified = true
            this.$emit('ok', {
              totalPeopleCnt: this.totalMemberCnt + this.totalVisitorCnt,
              memberAdults: this.memberAdults,
              memberChildrenCnt: this.totalChldMemberCnt,
              visitorAdults: this.visitorAdults,
              visitorChildrenCnt: this.totalChldVisitorCnt,
              memberChldDetails: this.memberChldDetails,
              visitorChldDetails: this.visitorChldDetails,
              totalDiscountAmount: this.totalDiscountAmount,
              totalAppliedCouponPrice: this.totalAppliedCouponPrice,
              couponOption: this.couponOption,
              stayNightDetails: this.stayNightDetails,
              verified: this.couponVerified,
              canUseOptional: this.canUseOptional
            })
          },
          (error) => {
            this.$loading.hide()
            let message = error.data?.message || ''
            if (message && typeof message === 'string') {
              message = message.substring(message.indexOf(':') + 1).trim()
              message = JSON.parse(
                message.substring(2).substring(0, message.substring(2).length - 1)
              )
              if (message && Array.isArray(message.errorResponseList)) {
                this.couponWarnings = message.errorResponseList.map((e) => e.errorDetail)
              }
            } else if (error.data && Array.isArray(error.data?.errorResponseList)) {
              this.couponWarnings = error.data?.errorResponseList.map(
                (e) => e.errorDetail
              )
            } else {
              this.$toasted.error(error.data?.message)
            }
          }
        )
        .catch(() => {
          this.$loading.hide()
        })
      this.$emit('getTotalCoupon', {
        couponForceTotal: this.totalForceUseDiscount,
        couponOptionTotal: this.totalDiscountAmount - this.totalForceUseDiscount
      })
    },
    markOutstockDays() {
      // this.outstockDayMap = {}
      const lastDay = moment(this.stayDay).endOf('month').date()
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      // const closeDays = []
      for (let i = 1; i <= lastDay; i++) {
        const month =
          moment(this.stayDay).month() + 1 > 9
            ? moment(this.stayDay).month() + 1
            : `0${moment(this.stayDay).month() + 1}`
        const day = `${moment(this.stayDay).year()}/${month}/${i > 9 ? i : `0${i}`}`
        if (!inStockDays.includes(day)) {
          // this.outstockDayMap[day] = true
          // closeDays.push(day)
        }
      }
      // return closeDays
    },
    useFullCoupon() {
      this.dump('useFullCoupon')
      const stayNightDetails = this.$_couponMixin_convertStayNightDetails(
        this.stayNights,
        cloneDeep(this.stayRoomDetails),
        this.subsidyData
      )
      this.dump('useFullCoupon stayNightDetails', stayNightDetails)
      const remainingSubsidys = cloneDeep(this.subsidyData)

      const result = this.$_couponMixin_applyCoupon({
        stayDay: this.stayDay,
        stayNights: this.stayNights,
        coupons: remainingSubsidys,
        vacancyCalendar: cloneDeep(this.vacancyCalendar),
        stayNightDetails
      })
      this.dump('useFullCoupon relationships result', result)

      if (result.totalDiscountAmount) {
        this.stayNightDetails = result.stayNightDetails
        this.remainingSubsidys = result.remainingSubsidys
        this.totalForceUseDiscount = result.totalForceUseDiscount
        this.totalDiscountAmount = result.totalDiscountAmount
        this.totalAppliedCouponPrice = result.totalAppliedCouponPrice
        if (result.totalDiscountAmount === 0) {
          // auto select dont use coupons option
          this.couponOption = 2
        }
        this.dump('useFullCoupon this.totalDiscountAmount', this.totalDiscountAmount)
        this.dump('useFullCoupon this.totalForceUseDiscount', this.totalForceUseDiscount )
        if (this.totalDiscountAmount - this.totalForceUseDiscount === 0) {
          this.canUseOptional = false
        } else {
          this.canUseOptional = true
        }
        this.dump('useFullCoupon this.canUseOptional', this.canUseOptional)
      } else {
        this.couponOption = 2
      }
    },
    usePathOfCoupon() {
      // const remainingSubsidys = cloneDeep(this.remainingSubsidys)
      const remainingSubsidys = cloneDeep(this.subsidyData)

      // RESET useCnt & remainingCount
      const result = this.$_couponMixin_manualApplyCoupon({
        stayDay: this.stayDay,
        stayNights: this.stayNights,
        coupons: remainingSubsidys,
        vacancyCalendar: this.vacancyCalendar,
        stayNightDetails: this.stayNightDetails,
        options: {
          applyType: 'manual'
        }
      })

      if (result) {
        if (result.isChangeUsePlan) {
          // Show MESSAGE
          this.$toasted.error(
            '申請可能金額を超えているため、補助クーポンを選択できません。'
          )
        }
        this.stayNightDetails = result.stayNightDetails
        this.remainingSubsidys = result.remainingSubsidys
        this.totalForceUseDiscount = result.totalForceUseDiscount
        this.totalDiscountAmount = result.totalDiscountAmount
        this.totalAppliedCouponPrice = result.totalAppliedCouponPrice
      } else {
        // this.remainingSubsidys = result.remainingSubsidys
        this.totalForceUseDiscount = 0
        this.totalDiscountAmount = 0
        this.totalAppliedCouponPrice = 0
      }
      return result
    },
    notUseCoupon() {
      const remainingSubsidys = cloneDeep(this.forceUseSubsidys)

      const result = this.$_couponMixin_applyCoupon({
        stayDay: this.stayDay,
        stayNights: this.stayNights,
        coupons: remainingSubsidys,
        vacancyCalendar: this.vacancyCalendar,
        stayNightDetails: this.stayNightDetails,
        options: {
          applyOptional: false
        }
      })

      if (result) {
        this.stayNightDetails = result.stayNightDetails
        this.totalForceUseDiscount = result.totalForceUseDiscount
        this.totalDiscountAmount = result.totalDiscountAmount
        this.totalAppliedCouponPrice = result.totalAppliedCouponPrice
        if (result.totalDiscountAmount === 0) {
          // auto select dont use coupons option
          this.couponOption = 2
        }
      } else {
        this.totalForceUseDiscount = 0
        this.totalDiscountAmount = 0
        this.totalAppliedCouponPrice = 0
      }
    },
    couponList(dayDetails) {
      const forced = this.CONST_DATA.USED_FORM_DIV.FORCED;
      if (+this.couponOption === 0) {
        return (dayDetails.appliedCoupons || []).filter(
          (s) => s.availableData && s.availableData.usedFormDiv !== forced
        )
      } else {
        return this.remainingSubsidys.filter(
          (s) => s.availableData && s.availableData.usedFormDiv !== forced
        )
      }
    },
    checkLimApplicableDateFrom(day, price) {
      return (
        moment(price.limApplicableDateFrom).isSameOrBefore(day.stayDay, 'day') &&
        moment(price.limApplicableDateTo).isSameOrAfter(day.stayDay, 'day')
      )
    },
    /**
     * 宿泊日が、任意補助金の限定適用期間内に存在するかを判定し、
     * 画面表示可能かを戻り値とする関数
     * 
     * @param {*} day -> stayNightDetails[i]：各宿泊日の情報
     * @param {*} subsidy -> 該当の補助金情報
     * @return boolean -> 画面に表示させるかどうかの判定地
     */
    availableCheckForDate(day, subsidy) {

      this.dump('availableCheckForDate day', day)
      this.dump('availableCheckForDate subsidy', subsidy)

      // 利用可能判定用変数
      let isAvailable = false;
      // 補助金が料金情報を持たない場合は、空の配列で初期化する
      const priceList = subsidy.availableData.priceList || [];

      // 任意の補助金の料金情報リストでループ処理を行い、
      // 宿泊日が限定適用期間内に存在する場合は利用可能とし、処理を抜ける
      for(let i = 0; i < priceList.length; i++) {
        if(
          moment(priceList[i].limApplicableDateFrom).isSameOrBefore(day.stayDay, 'day') &&
          moment(priceList[i].limApplicableDateTo).isSameOrAfter(day.stayDay, 'day')
        ) {
          isAvailable = true;
          break;
        }
      }

      this.dump('availableCheckForDate isAvailable', isAvailable)
      return isAvailable;
    },
    availableCheckAccompany(day, subsidy) {
      // 本人同行申請：不要の場合は利用可能
      if(subsidy.availableData.personAccompanyFlg == 0)
      {
        return true
      }
      // 本人同行申請：要の場合、本人がいれば利用可能
      for(let room of day.rooms){
        for(let rel of room.relationships)
        {
          if(+rel.relationship.relationshipId === 0){
            return true
          }
        }
      }
      // どちらにも該当しない場合は利用不可
      return false
    },
    handleOk() {
      this.checkSubsidy()
    },
    handleCancel() {
      this.couponOption = this.appliedCouponData.couponOption || 0
      this.$emit('cancel')
    },
    checkDisableByAgeType(ageType){
      return ageType === COUPON_AGE_TYPE.ADULT && !get(this.bsAppState.bs_app_02_001, 'totalAdultPeople', 0) || ageType === COUPON_AGE_TYPE.CHILDREN && !get(this.bsAppState.bs_app_02_001, 'totalChildren', 0)

    },
    checkDisableOptionalCouponNum(price) {
      // ベストチョイスの条件により枚数選択できないと判定された場合trueを返す
      return !price.enabledChangeOptionalCouponCnt;
    },
    /**
    * 企業補助金か判定する
    */
    isCorporate(availableData) {
      if ( availableData.requestType == this.CONST_DATA.SUBSIDY_REQUEST_TYPE.CORPORATE) {
        return true
      }
      return false
    },
    /**
    * 画面表示用：上限枚数を取得
    * @arg     object[subsidyList]
    * @return: array
    */
    remainingCountLabel(subsidy) {
      let countLabelArr = subsidy?.scrennDisplayItemList?.remainingCountLabel?.value?.split(',') || []
      let countLabel = []
      countLabelArr.forEach((val) => {
        if (!val.includes('上限回数') && !val.includes('|null')) {
          countLabel.push(val.replace('|', '：'))
        }
      })
      return countLabel
    },
    /**
    * 画面表示用：上限金額を取得
    * @arg     object[subsidyList]
    * @return  array
    */
    remainingAmountLabel(subsidy) {
      let amountLabelArr = subsidy.scrennDisplayItemList?.remainingAmountLabel?.value?.split(',') || []
      let amountLabel = []
      amountLabelArr.forEach((val) => {
        if (!val.includes('上限金額') && !val.includes('|null')) {
          amountLabel.push(val.replace('|', '：'))
        }
      })
      return amountLabel
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
